import { render, staticRenderFns } from "./BiosignsScanPacksTable.vue?vue&type=template&id=67c9319b"
import script from "./BiosignsScanPacksTable.vue?vue&type=script&lang=js"
export * from "./BiosignsScanPacksTable.vue?vue&type=script&lang=js"
import style0 from "./BiosignsScanPacksTable.vue?vue&type=style&index=0&id=67c9319b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports